import React, { useState } from "react";
import MultiBenefitDiscountModal from "../../../Modals/SpecialOffersModals/MultiBenefitDiscount/MultiBenefitDiscountModal";

interface IMultiBenefitDiscountOfferProps {
    providerId: number;
    providerName?: string;
}

const MultiBenefitDiscountOffer: React.FC<IMultiBenefitDiscountOfferProps> = (props) => {
    const { providerId, providerName } = props;

    const [isOpen, setIsOpen] = useState(false);

    const onClose = (): void => {
        setIsOpen(false);
    };

    return (
        <React.Fragment>
            <MultiBenefitDiscountModal
                providerId={providerId}
                isOpen={isOpen}
                onClose={onClose}
            />
            <a onClick={() => setIsOpen(true)}>
                {providerName ? `${providerName} ` : ""}Multi-benefit discounts
            </a>
        </React.Fragment>
    );
};

export default React.memo(MultiBenefitDiscountOffer);
